import { type IconProps } from './types'

export function YoutubeIcon({ width = '24', height = '24' }: IconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M45.0013 35.3125C44.5846 37.5 42.8138 39.1667 40.6263 39.4792C37.1888 40 31.4596 40.625 25.0013 40.625C18.6471 40.625 12.918 40 9.3763 39.4792C7.1888 39.1667 5.41797 37.5 5.0013 35.3125C4.58464 32.9167 4.16797 29.375 4.16797 25C4.16797 20.625 4.58464 17.0833 5.0013 14.6875C5.41797 12.5 7.1888 10.8333 9.3763 10.5208C12.8138 10 18.543 9.375 25.0013 9.375C31.4596 9.375 37.0846 10 40.6263 10.5208C42.8138 10.8333 44.5846 12.5 45.0013 14.6875C45.418 17.0833 45.9388 20.625 45.9388 25C45.8346 29.375 45.418 32.9167 45.0013 35.3125Z"
        fill="#FF3D00"
      />
      <path d="M20.832 32.2916V17.7083L33.332 24.9999L20.832 32.2916Z" fill="white" />
    </svg>
  )
}
